import React from 'react';

import { Heading, Menu } from '../../../components';



const MenuSection = () => {

  return (
    <section className="menu">

      {/* Section Heading */}
      <Heading title={'Our menu'} subTitle={'What we offer'} />

      {/* Menu Component */}
      <Menu />

    </section>
  );
};

export default MenuSection;